import { Theme, useMediaQuery } from '@mui/material';

export const useDesktopQuery = () =>
  useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

export const useMobileQuery = () =>
  useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));
